import * as React from 'react';

import { Link } from 'react-router-dom';

import { inject } from 'mobx-react';

// shared-ui
import { useLocalization, LocalizedText, ILocalization } from '@shared-ui/localization-context';

import { UitkBanner } from 'uitk-react-banner';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkLink } from 'uitk-react-link';
import { UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkPrimaryButton } from 'uitk-react-button';

interface PreviewBannerProps {
  link: string;
  externalLink?: boolean;
  l10n?: ILocalization;
}

export const PreviewBanner: React.FunctionComponent<PreviewBannerProps> = ({ link, l10n, externalLink }) => {
  return (
    <div className="preview">
      <UitkBanner icon="info_outline" message={l10n.formatText('preview.products.banner.text')}>
        <UitkLink inline={true}>
          {externalLink ? (
            <UitkLink inline={true}>
              <a href={link}>
                <LocalizedText message="preview.products.join.the.program" />
              </a>
            </UitkLink>
          ) : (
            <Link to={link} className="a--no-hover">
              <LocalizedText message="preview.products.join.the.program" />
            </Link>
          )}
        </UitkLink>
      </UitkBanner>
    </div>
  );
};
